/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { FragmentsCreateFragmentSocialPublishMutationRequest, FragmentsCreateFragmentSocialPublishMutationResponse, FragmentsCreateFragmentSocialPublishPathParams, FragmentsCreateFragmentSocialPublish401, FragmentsCreateFragmentSocialPublish403, FragmentsCreateFragmentSocialPublish404 } from "../models/FragmentsCreateFragmentSocialPublish";

export function getFragmentsCreateFragmentSocialPublishUrl(fragmentId: FragmentsCreateFragmentSocialPublishPathParams["fragmentId"]) {
  const res = { method: 'POST', url: `/fragments/v1/${fragmentId}/social-publish` as const }
  return res
}

/**
 * @description Starts publishing the fragment video (or audio) to the given social connection.
 * You can call this while the video is still being prepared:
 * - If the video is already ready, publishing starts right away.
 * - If not, the publish is created in a waiting state (`waitingForMedia: true`) and continues automatically once the video is ready. If preparation fails or the fragment is deleted, the publish is marked as failed.
 * Title, description, and tags default from the fragment; values in `data` override them. Use the returned upload (and upload status endpoints) to follow progress.
 * @summary Publish a fragment to a social connection (allowed before the video is ready)
 * {@link /fragments/v1/:fragmentId/social-publish}
 */
export async function fragmentsCreateFragmentSocialPublish(fragmentId: FragmentsCreateFragmentSocialPublishPathParams["fragmentId"], data: FragmentsCreateFragmentSocialPublishMutationRequest, config: Partial<RequestConfig<FragmentsCreateFragmentSocialPublishMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<FragmentsCreateFragmentSocialPublishMutationResponse, ResponseErrorConfig<FragmentsCreateFragmentSocialPublish401 | FragmentsCreateFragmentSocialPublish403 | FragmentsCreateFragmentSocialPublish404>, FragmentsCreateFragmentSocialPublishMutationRequest>({ method : "POST", url : getFragmentsCreateFragmentSocialPublishUrl(fragmentId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}